export default "__VITE_ASSET__CTzpP0SB__"